var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageAsset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.406006V14.5941H17V0.406006H0ZM1.30425 1.73206H15.6957V13.2681H1.30425V1.73206ZM4.27075 3.3974C3.86488 3.3974 3.52338 3.53569 3.24665 3.81244C2.96991 4.08918 2.83161 4.43067 2.83161 4.83655C2.83161 5.22399 2.96991 5.55589 3.24665 5.83263C3.52338 6.10938 3.86488 6.24767 4.27075 6.24767C4.65818 6.24767 4.99011 6.10936 5.26686 5.83263C5.5436 5.5559 5.6819 5.22398 5.6819 4.83655C5.6819 4.43067 5.54359 4.08918 5.26686 3.81244C4.99012 3.53569 4.65818 3.3974 4.27075 3.3974ZM10.3863 4.09882L7.12103 9.05231L5.3872 7.61316L2.83161 10.9335V11.9026H14.1684V8.00953L10.3863 4.09882Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageAsset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/imageAsset.2642a1217b824801d2992fc27ed770ee.svg";